export default {
  getSideBarState: state => state.sidebar.open,
  displayBpSelectionDialog: state => state.bpSelectionDialog.display,
  displayOverrideThemeBpsDialog: state => state.overrideThemeBpsDialog.display
};
